<template>
  <div class="beian">
    ©2017 G9ZZ.  <a href="https://github.com/g9zz" target="_blank"> 关于我们</a>
    <a href="http://www.beian.miit.gov.cn/" target="_blank">皖ICP备15017682号</a>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue